import { useEffect, useRef, useState } from 'react';
import { GetStartPageUrl } from 'src/utils/URLUtils';
import { useNote } from '../../hook/components/useNote';
import { useGeneralSettings } from '../../hook/data/useGeneralSettings';
import { useLearning } from '../../hook/data/useLearning';
import useProgress from '../../hook/data/useProgress';
import { useSocial } from '../../hook/data/useSocial';
import useUser from '../../hook/data/useUser';

export const LogOut = () => {
    const { handleLogout: userLogout } = useUser();
    const { handleLogout: learningLogout } = useLearning();
    const { handleLogout: notesLogout } = useNote();
    const { handleLogout: socialLogout } = useSocial();
    const { handleLogout: generalSettingsLogout } = useGeneralSettings();
    const { handleLogout: progressLogout, uploadProgressAtomic } = useProgress();
    const [isLoggingOut, setIsLoggingOut] = useState(false);
    const hasRun = useRef(false);

    useEffect(() => {
        if (hasRun.current || isLoggingOut) return;

        const performLogout = async () => {
            try {
                setIsLoggingOut(true);
                hasRun.current = true;

                // Logout from all contexts
                await Promise.all([
                    uploadProgressAtomic(),
                    userLogout(),
                    learningLogout(),
                    notesLogout(),
                    socialLogout(),
                    generalSettingsLogout(),
                    progressLogout()
                ]);

                // Wait for next render cycle to ensure state updates are processed
                await new Promise(resolve => requestAnimationFrame(resolve));

                // Now navigate after all updates are complete
                window.location.href = GetStartPageUrl();
            } catch (error) {
                console.error('Logout failed:', error);
                // Still redirect even if logout fails
                window.location.href = GetStartPageUrl();
            }
        };

        performLogout();

        // Cleanup function
        return () => {
            hasRun.current = true;
        };
    }, [uploadProgressAtomic, userLogout, learningLogout, notesLogout, socialLogout, generalSettingsLogout, progressLogout, isLoggingOut]);

    return null;
};

export default LogOut;
